export enum FONTS_ACTIONS {
    BEGIN_LOADING_FONTS = 'BEGIN_LOADING_FONTS',
    STORE_FONTS = 'STORE_FONTS',
    ARCHIVE_FONT_WITH_ID = 'ARCHIVE_FONT_WITH_ID',
}
